import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllMajorCategories } from '../redux/user/majorcategories/majorCategories_service_syn';
import LoaderScreen from '../component/loader/loaderScreen';

const BannerSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { majorCategories, loading } = useSelector((state) => state.majorCategories);

  useEffect(() => {
    dispatch(getAllMajorCategories({ page: 1, limit: 6 })); // Fetch 6 categories
  }, [dispatch]);

  const handleCategoryClick = (categoryName) => {
    navigate(`/categories/${categoryName}`);
  };

  if (loading) {
    return (
      <section className="banner__section section--padding">
        <div className="container-fluid">
          <div className="d-flex justify-content-center">
            <LoaderScreen />
          </div>
        </div>
      </section>
    );
  }

  const categoriesArray = majorCategories?.data?.docs || [];

  return (
    <section className="banner__section section--padding">
      <div className="container-fluid">
        <div className="row mb--n28">
          {categoriesArray.length > 0 ? (
            categoriesArray.map((category) => (
              <div className="col-lg-6 col-md-6 col-sm-6 mb-28" key={category._id}>
                <div className="banner__items">
                  <div
                    className="banner__items--thumbnail position__relative"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleCategoryClick(category.name)}
                  >
                    <img
                      className="banner__items--thumbnail__img"
                      src={category.category_image || 'assets/img/default-category.jpg'}
                      alt={category.name}
                      style={{ width: '80%', height: '45vh', objectFit: 'contain', objectPosition: 'center' }}
                    />
                    <div className="banner__items--content">
                      <h2 className="banner__items--content__title">{category.name}</h2>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <p>No categories available</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
